export const TRUSTLY_KYC_ONLY_DEEPLINK_URL = `betrpickem://trustly-kyc-only-status`;
export const TRUSTLY_KYC_ONLY_UNIVERSAL_LINK_URL = `https://link.betr.app/trustly-kyc-only-status`;
export const TRUSTLY_APP_TO_APP_RETURN_URL = `betrpickem://trustly-oauth-return`;
